// must be first: patches process.nextTick before @react-pdf's stream shims load
import "./polyfills";
import * as React from "react";
import * as ReactDOM from "react-dom";

import App from "./App";
// antd component CSS must load BEFORE the app SCSS so the src/scss/ant/
// override layer wins the cascade
import "./antd-styles";
import "./scss/index.scss";
import "src/assets/fonts/inter.css";
import "react-toastify/dist/ReactToastify.css";

ReactDOM.render(<App />, document.getElementById("root") as HTMLElement);

// service workers need more work before using in an app. (ie notification of a new version)
// unregister any previously-registered service worker
if ("serviceWorker" in navigator) {
	navigator.serviceWorker.ready.then((r) => r.unregister()).catch(() => {});
}
